<template>
  <v-card outlined class="card-center">
    <v-container class="px-1 py-1" fluid>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-card flat>
          <v-card-title>
            {{ $t('ELE0028') }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <InspecionCompanyInput v-model="searchCondition.inspCompany" required />
              </v-col>
              <v-col>
                <SelectMultipleInput
                  :label="$t('ELE0217')"
                  v-model="searchCondition.approveStatsCd"
                  :items="approveStatusCdList"
                  item-text="name"
                  item-value="value"
                  required
                />
              </v-col>
              <v-col cols="3">
                <TextFieldInput :label="$t('ELE0049')" v-model="searchCondition.lotNo" />
              </v-col>
              <v-col cols="2">
                <TextFieldInput :label="$t('ELE0031')" v-model="searchCondition.partCd" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <TextFieldInput :label="$t('ELE0137')" v-model="searchCondition.inspIndexNo" />
              </v-col>
              <v-col cols="3">
                <TextFieldInputWithDatePicker :label="$t('ELE0138')" v-model="searchCondition.inspDateFrom" />
              </v-col>
              <span class="px-4 py-2 mt-3"> {{ $t('ELE0141') }} </span>
              <v-col cols="3">
                <TextFieldInputWithDatePicker :label="$t('ELE0138')" v-model="searchCondition.inspDateTo" />
              </v-col>
              <v-col cols="2">
                <TextFieldInput :label="$t('ELE0224')" v-model="searchCondition.model" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <InspCat1MultipleInput v-model="searchCondition.inspCat1" />
              </v-col>
              <v-col cols="4">
                <InspCat2MultipleInput v-model="searchCondition.inspCat2" />
              </v-col>
              <v-spacer />
              <v-col class="d-flex justify-end">
                <BtnSearch @click="onClickSearch" :disabled="invalid" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </ValidationObserver>
      <v-card outlined>
        <v-card-title class="pt-1 pb-0">
          {{ $t('ELE0023') }}
        </v-card-title>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" show-select item-key="wfNo" dense>
          <template v-if="!canSelect" v-slot:header.data-table-select>
            <v-simple-checkbox disabled />
          </template>
          <template v-if="!canSelect" v-slot:item.data-table-select>
            <v-simple-checkbox disabled />
          </template>
          <template v-slot:item.inquiry="{ item }">
            <IconInquiry @click="onClickInquiry(item)" />
          </template>
          <template v-slot:item.statusCd="{ item }">
            <td :class="[`result-background-color-${item.statusCd}`, 'v-data-table__divider']">
              {{ $t('ApproveStatusCd.' + item.statusCd) }}
            </td>
          </template>
          <template v-slot:item.inspResult="{ item }">
            {{ getInspResultName('InspResultCd.', item.inspResult, item.isOutCl) }}
          </template>
          <template v-slot:item.mmmmApplNo="{ item }">
            <div class="d-flex align-center">
              {{ item.mmmmApplNo }}
              <IconInquiry v-if="can4MClicked(item)" @click="onClickMmmmSub(item)" />
            </div>
          </template>
          <template v-slot:item.mmmmDispositionCd="{ item }">
            {{ item.mmmmDispositionCd ? $t('MmmmDispositionCd.' + item.mmmmDispositionCd) : '' }}
          </template>
        </v-data-table>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col class="d-flex flex-row justify-end">
              <Btn class="mx-2" :label="$t('ELE0216')" @click="onClickCheck" isCheckRole :disabled="!canCheck" />
              <Btn class="ml-2" :label="$t('ELE0215')" @click="onClickApprove" isCheckRole :disabled="!canApprove" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <ApprovalInspDataListDialog
      v-if="approvalInspDataListDialog"
      :dialog.sync="approvalInspDataListDialog"
      :inspIndexNo="inspIndexInfo.inspIndexNo"
      :inspCompanyCd="inspIndexInfo.inspCompanyCd"
      :lotNo="inspIndexInfo.lotNo"
      :partCd="inspIndexInfo.partCd"
      :partName="inspIndexInfo.partName"
      :lotDate="inspIndexInfo.lotDate"
      :wfNo="inspIndexInfo.wfNo"
      :wfVersionNo="inspIndexInfo.wfVersionNo"
      :inspIndexVersionNo="inspIndexInfo.inspIndexVersionNo"
      :statusCd="inspIndexInfo.statusCd"
      :canCheck="canCheck"
      :canApprove="canApprove"
      :canReturnToRequest="canReturnToRequest"
      :inspCat1="inspIndexInfo.inspCat1"
      :inspCat2="inspIndexInfo.inspCat2"
      @close="onClickSearch"
    />
    <SearchMmmmSubDialog
      v-if="mmmmSubDialog"
      :dialog.sync="mmmmSubDialog"
      :inspCompanyCd="selectedMmmmItems.inspCompanyCd"
      :inspCompanyName="selectedMmmmItems.inspCompanyName"
      :lotNo="selectedMmmmItems.lotNo"
      :partCd="selectedMmmmItems.partCd"
      :inspIndexNo="selectedMmmmItems.inspIndexNo"
      @close="onClickSearch"
    />
    <v-dialog v-if="mmmmDialog" v-model="mmmmDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0491') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="mmmmDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <MmmmRequestForm :propsMmmmNo="selected4MLink" isModal @close="mmmmDialog = false" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment'
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import { ApproveStatusCd, CompanyCatCd, InspectionIndex4M } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import Btn from '@/components/atoms/base/button/Btn'

import InspecionCompanyInput from '@/components/atoms/select/InspecionCompanyInput'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import ApprovalInspDataListDialog from '@/components/organisms/terminal/dialog/ApprovalInspDataListDialog'
import InspCat1MultipleInput from '@/components/atoms/select/InspCat1MultipleInput'
import InspCat2MultipleInput from '@/components/atoms/select/InspCat2MultipleInput'
import MmmmRequestForm from '@/components/organisms/terminal/form/MmmmRequestForm.vue'
import SearchMmmmSubDialog from '@/components/organisms/terminal/dialog/SearchMmmmSubDialog'

export default {
  name: 'ApproveInspDataForm',

  mixins: [APIUtils, Message, Loading, DateUtil, StringUtils],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    SelectMultipleInput,
    BtnLink,
    Btn,
    InspecionCompanyInput,
    BtnSearch,
    IconInquiry,
    ApprovalInspDataListDialog,
    InspCat1MultipleInput,
    InspCat2MultipleInput,
    MmmmRequestForm,
    SearchMmmmSubDialog,
  },

  computed: {
    enumApproveStatusCd: () => ApproveStatusCd,
    approveStatusCdList: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(ApproveStatusCd).map((item) => {
          return { name: item + ': ' + this.$t(`ApproveStatusCd.${item}`), value: item }
        })
      },
    },
    canCheck: {
      get() {
        let result = false
        if (this.$store.getters.hasRole('INSPECTION_RESULT_CHECK')) {
          if (
            this.selectedItems.length > 0 &&
            this.selectedItems.every((item) => item.statusCd === ApproveStatusCd.WAITING_FOR_CHECK)
          ) {
            result = true
          }
        }
        return result
      },
    },
    canApprove: {
      get() {
        let result = false
        if (this.$store.getters.hasRole('INSPECTION_RESULT_APPROVE')) {
          if (
            this.selectedItems.length > 0 &&
            this.selectedItems.every((item) => item.statusCd === ApproveStatusCd.WAITING_FOR_APPROVE)
          ) {
            result = true
          }
        }
        return result
      },
    },
    canSelect: {
      get() {
        let result = false
        if (this.items.length > 0) {
          if (
            this.$store.getters.isEpson &&
            this.items.every((item) => item.m_company.companyCatCd == CompanyCatCd.EPSON)
          ) {
            result = true
          }
          if (this.$store.getters.companyCd === this.searchCondition.inspCompany) {
            result = true
          }
        }
        return result
      },
    },
  },

  data() {
    return {
      selectedItems: [],
      mmmmSubDialog: false,
      approvalInspDataListDialog: false,
      inspIndexInfo: {},
      searchCondition: {
        inspCompany: this.$store.getters.companyCd,
        approveStatsCd: [ApproveStatusCd.WAITING_FOR_CHECK, ApproveStatusCd.WAITING_FOR_APPROVE],
        lotNo: '',
        partCd: '',
        model: '',
        inspIndexNo: '',
        inspDateFrom: moment().format('YYYY-MM-DD'),
        inspDateTo: moment().format('YYYY-MM-DD'),
        inspCat1: [],
        inspCat2: [],
      },
      headers: [
        { text: '', value: 'inquiry', divider: true, cellClass: 'mx-0 px-0', sortable: false },
        { text: this.$t('ELE0217'), value: 'statusCd', divider: true },
        { text: this.$t('ELE0188'), value: 'inspResult', divider: true },
        { text: this.$t('ELE0048'), value: 'inspCompany', divider: true },
        { text: this.$t('ELE0137'), value: 'inspIndexNo', divider: true },
        { text: this.$t('ELE0049'), value: 'lotNo', divider: true },
        { text: this.$t('ELE0031'), value: 'partCd', divider: true },
        { text: this.$t('ELE0032'), value: 'partName', divider: true },
        { text: this.$t('ELE0224'), value: 'model', divider: true },
        { text: this.$t('ELE0116'), value: 'inspCat1Name', divider: true },
        { text: this.$t('ELE0117'), value: 'inspCat2Name', divider: true },
        { text: this.$t('ELE0545'), value: 'mmmmApplNo', divider: true },
        { text: this.$t('ELE0505'), value: 'mmmmDispositionCd' },
      ],
      items: [],
      canReturnToRequest: false,
      mmmmDialog: false,
      selected4MLink: null,
    }
  },

  methods: {
    onClickInquiry(item) {
      this.inspIndexInfo = {
        inspIndexNo: item.inspIndexNo,
        inspCompanyCd: item.t_inspIndex.inspCompanyCd,
        lotNo: item.lotNo,
        partCd: item.partCd,
        partName: item.partName,
        lotDate: this.toLocalDate(item.t_inspIndex.inspCreateDatetime),
        filtering: item.m_inspFilteringGroup.inspFilteringGroupName,
        wfNo: item.wfNo,
        wfVersionNo: item.versionNo,
        inspIndexVersionNo: item.t_inspIndex.versionNo,
        statusCd: item.statusCd,
        inspCat1: item.t_inspIndex.inspCat1,
        inspCat2: item.t_inspIndex.inspCat2,
      }
      if (this.canSelect) {
        this.selectedItems = [item]
      }
      this.canReturnToRequest = this.getReturnToRequest(item)
      this.approvalInspDataListDialog = true
    },
    async onClickCheck() {
      this.startLoading()
      try {
        const items = this.selectedItems
        if (!items.length) {
          return
        }
        if (items.some((item) => item.statusCd != ApproveStatusCd.WAITING_FOR_CHECK)) {
          this.setErrorMessage(
            this.$t('MSG0082', { p0: this.$t(`ApproveStatusCd.${ApproveStatusCd.WAITING_FOR_CHECK}`) }),
          )
          return
        }
        const body = {
          wfList: items.map((item) => {
            return {
              wfNo: item.wfNo,
              versionNo: item.versionNo,
            }
          }),
          userCd: this.$store.getters.userCd,
        }
        await API.post('/inspIndex/approves/check/', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0139') }))
        this.onClickSearch()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickApprove() {
      this.startLoading()
      try {
        const items = this.selectedItems
        if (!items.length) {
          return
        }
        if (items.some((item) => item.statusCd != ApproveStatusCd.WAITING_FOR_APPROVE)) {
          this.setErrorMessage(
            this.$t('MSG0082', { p0: this.$t(`ApproveStatusCd.${ApproveStatusCd.WAITING_FOR_APPROVE}`) }),
          )
          return
        }
        const body = {
          wfList: items.map((item) => {
            return {
              wfNo: item.wfNo,
              versionNo: item.versionNo,
            }
          }),
          userCd: this.$store.getters.userCd,
        }
        await API.post('/inspIndex/approves/approve/', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0139') }))
        this.onClickSearch()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickSearch() {
      this.startLoading()
      this.selectedItems = []
      try {
        const params = {
          inspCompany: this.searchCondition.inspCompany,
          approveStatsCd: this.searchCondition.approveStatsCd,
          lotNo: this.searchCondition.lotNo,
          partCd: this.searchCondition.partCd,
          model: this.searchCondition.model,
          inspIndexNo: this.searchCondition.inspIndexNo,
          inspDateFrom: this.searchCondition.inspDateFrom,
          inspDateTo: this.searchCondition.inspDateTo,
          inspCat1: this.searchCondition.inspCat1,
          inspCat2: this.searchCondition.inspCat2,
        }
        this.items = []
        const elements = await API.get('/inspIndex/approves', params)
        elements.forEach((element) => {
          element['check'] = false
          element['inspResult'] = element['t_inspIndex']['inspResultCd']
          element['isOutCl'] = element['t_inspIndex']['isOutCl']
          element['inspCompany'] = element['m_company']['companyName']
          element['inspIndexNo'] = element['t_inspIndex']['inspIndexNo']
          element['lotNo'] = element['t_inspIndex']['lotNo']
          element['filtering'] = element['m_inspFilteringGroup']['inspFilteringGroupName']
          element['partCd'] = element['m_part']['partCd']
          element['partName'] = element['m_part']['partName']
          element['model'] = element['m_part']['model']
          element['inspCat1Name'] = element['m_inspCat1']['inspCatName']
          element['inspCat2Name'] = element['m_inspCat2']['inspCatName']
          element['mmmmApplNo'] = element['t_inspIndex']['mmmmApplNo']
          if (element['t_mmmmWf']) {
            element['mmmmDispositionCd'] = element['t_mmmmWf']['dispositionCd']
          }
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0217') })))
      } finally {
        this.stopLoading()
      }
    },
    getReturnToRequest(item) {
      let result = false
      if (this.canSelect) {
        if (this.$store.getters.hasRole('INSPECTION_RESULT_CHECK')) {
          if (
            item.statusCd === ApproveStatusCd.WAITING_FOR_CHECK ||
            item.statusCd === ApproveStatusCd.WAITING_FOR_APPROVE
          ) {
            result = true
          }
        }
        if (this.$store.getters.hasRole('INSPECTION_RESULT_APPROVE')) {
          if (item.statusCd === ApproveStatusCd.WAITING_FOR_APPROVE || item.statusCd === ApproveStatusCd.APPROVED) {
            result = true
          }
        }
      }

      return result
    },
    onClickMmmmSub(item) {
      this.selectedMmmmItems = {
        inspIndexNo: item.inspIndexNo,
        inspCompanyCd: item.m_company.companyCd,
        inspCompanyName: item.m_company.companyName,
        lotNo: item.lotNo,
        partCd: item.partCd,
      }
      this.mmmmSubDialog = true
    },
    can4MClicked(item) {
      if (item.mmmmApplNo && item.mmmmApplNo != InspectionIndex4M.NOT_STARTED_YET) {
        return true
      }
      return false
    },
    onClick4MLink(item) {
      this.selected4MLink = item.mmmmApplNo
      this.mmmmDialog = true
    },
  },
}
</script>

<style>
.result-background-color-0 {
  background-color: #ffffff;
}
.result-background-color-1 {
  background-color: #fcf4a1;
}
.result-background-color-2 {
  background-color: #f8ced2;
}
.result-background-color-3 {
  background-color: #bdbdbd;
}
</style>
